export default "__VITE_ASSET__tAWH9xWK__"